<mat-nav-list class="side-navbar" [attr.isCollapsed]="isSideNavCollapsed ? '1' : ''">
  <ng-container *ngFor="let menuItem of menuList; index as i">
    <ng-container *ngIf="menuItem?.isVisible ?? true">
      <ng-container
        [ngTemplateOutlet]="menuItem?.children ? childMenu : parentMenu"
        [ngTemplateOutletContext]="{ $implicit: menuItem }"
      ></ng-container>
    </ng-container>
  </ng-container>
</mat-nav-list>

<!-- start parent template -->

<ng-template class="menu" #parentMenu [dataItemContext]="menuList" let-menu>
  <mat-list-item
    class="menu"
    [routerLink]="menu?.routerLink ? '/'+menu?.routerLink : null"
    [queryParams]="menu.queryParams ? menu.queryParams.displayValue() : {}"
    routerLinkActive="is-active"
    [routerLinkActiveOptions]="{ exact: false }"
    (isActiveChange)="onClickSideMenuItem($event)"
  >
    <!-- start nav-container-item -->
    <app-side-nav-item [menu]="menu" [isSideNavCollapsed]="isSideNavCollapsed" class="parent-menu"></app-side-nav-item>
    <!-- end nav-container-item -->
  </mat-list-item>
</ng-template>

<!-- end parent template -->

<!-- start child template -->

<ng-template #childMenu [dataItemContext]="menuList" let-menu>
  <mat-expansion-panel class="menu" [class.mat-elevation-z0]="true">
    <!-- start mat expansion header -->
    <mat-expansion-panel-header [ngClass]="isSideNavCollapsed ? 'collapsed' : ''">
      <!-- start nav-container-item -->
      <app-side-nav-item [menu]="menu" [isSideNavCollapsed]="isSideNavCollapsed" class="parent-menu"></app-side-nav-item>
      <!-- end nav-container-item -->
    </mat-expansion-panel-header>
    <!-- end mat expansion header -->

    <!-- -------- -->
    <!-- start mat expansion body -->
    <ng-container>
      <mat-nav-list class="submenu" [attr.isCollapsed]="isSideNavCollapsed ? '1' : ''">
        <ng-container *ngFor="let submenu of menu.children">
          <mat-list-item
            *ngIf="submenu?.isVisible ?? true"
            [routerLink]="submenu.routerLink ? '/'+submenu.routerLink : null"
            [queryParams]="submenu.queryParams ? submenu.queryParams.displayValue() : {}"
            routerLinkActive="is-active"
            [routerLinkActiveOptions]="{ exact: false }"
            (isActiveChange)="onClickSideMenuItem($event)"
          >
            <!-- start nav-container-item -->
            <app-side-nav-item [menu]="submenu" [isSideNavCollapsed]="isSideNavCollapsed" class="sub-menu"></app-side-nav-item>
            <!-- end nav-container-item -->
          </mat-list-item>
        </ng-container>
      </mat-nav-list>
    </ng-container>
  </mat-expansion-panel>
</ng-template>

<!-- end child template -->
